import DataStore from "components/Store/DataStore";
import { action, extendObservable } from "mobx";

class Store extends DataStore {
  constructor() {
    super();

    extendObservable(this, {
      data: { message: "", time: "" },

      setMessage: action(this.setMessage),
    });
  }

  async setMessage(message) {
    this.data.message = message;
    this.data.time = +new Date();
    this.data.visible = false;
  }

  async setVisibleMessage(message) {
    this.data.message = message;
    this.data.time = +new Date();
    this.data.visible = true;
  }
}

const store = new Store({});

export default store;
